import { ChevronRight } from 'lucide-react';
import type { BreadcrumbsProps } from './Breadcrumbs.types';
import './Breadcrumbs.scss';

export default function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className={['breadcrumbs', className || ''].filter(Boolean).join(' ')}>
      <ol className="breadcrumbs__list">
        {items.map((it, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={`${it.label}-${i}`} className="breadcrumbs__item">
              {it.href && !isLast ? (
                <a href={it.href} className="breadcrumbs__link">{it.label}</a>
              ) : (
                <span className="breadcrumbs__current" aria-current={isLast ? 'page' : undefined}>{it.label}</span>
              )}
              {!isLast ? (
                <span className="breadcrumbs__sep" aria-hidden="true"><ChevronRight size={14} /></span>
              ) : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
